<template>
<div class="pb-3 pt-3 shadow" id="step-manager">
	<div class="text-center">

		<ul class="d-flex pl-4 pr-4 justify-content-around">
			<li v-for="(step, index) in steps">
				<a href="#" class="btn btn-circle btn-lg" :class="{
							'text-primary' : currentStep >= index,
							'btn-primary':currentStep >= index,
							'text-secondary' : currentStep < index,
							'bg-gray-500' : currentStep < index}" @click.prevent="goToStep(index)">
					<span class="numero" >{{ index + 1}}</span>
				</a>
        <span class="step-bar " :class="{
							'text-primary' : currentStep-1 >= index,
							'btn-primary':currentStep -1>= index,
							'text-secondary' : currentStep -1< index,
							'bg-gray-500' : currentStep-1 < index}"></span>
			</li>
      <li >
        <a href="#" class="btn btn-circle btn-lg text-secondary bg-gray-500">
          <span class="numero"><i class="fas fa-check"></i> </span>
        </a>
        <span class="step-bar"></span>
      </li>
		</ul>
	</div>
</div>
</template>

<style>
.numero {
	color: #fff;
  font-weight:600;
	position: absolute;
	padding-left: -10px;
}

#step-manager{
  background-color: #e4e4e4;
}

#step-manager li {
  list-style: none;
  position: relative;
  display: flex;
  flex: 1;
  margin: 0;
  align-items: center;
}
#step-manager li a{
  position: relative;z-index: 2;
  border: none;
}
#step-manager li span.step-bar{
	height: 5px;
  flex: 1;
	z-index: 1;
}
#step-manager li:last-of-type{
  flex: 0;
}
#step-manager li:last-of-type span.step-bar{
  display: none;
}

#step-manager ul{
  margin-bottom: 0;
}
.text {
	margin-top: 4.5em;
}
</style>

<script>
import {
	EventManager
} from '@/components/Events/EventManager.js'
export default {
	name: 'StepManager',
	props: ['steps'],
	components: {
		EventManager
	},
	data: function() {
		return {
			currentStep: 0
		}
	},
	created() {
		var that = this;
		EventManager.$on('do-next', function() {
			that.currentStep++;
		});

		EventManager.$on('do-prev', function() {
			that.currentStep--;
		});

		EventManager.$on('go-to-step-validate', function(step) {
			that.currentStep = step;
		});



	},
	methods: {
		goToStep: function(index) {
			EventManager.$emit('go-to-step', index);
		}
	}
}
</script>
